export enum FavouriteEntity {
  RAW_STOCK = "RAW_STOCK",
  WASTAGE = "WASTAGE",
  STAFF_FOOD = "STAFF_FOOD",
  STOCK_TRANSFER = "STOCK_TRANSFER",
  DASHBOARD = "DASHBOARD",
}
